import React from "react";
import { Container , Row , Col } from "react-bootstrap";
import ReadMore from "../../CommonUI/ReadMoreBtn/ReadMore";
import Tradetrontool from "../../../Images/tradetrontool.png";
import "./TradeTron.css";
import { useNavigate } from "react-router";

function TradeTron(){
    let navigate = useNavigate();
    const routeTradetron = () => {
        let path = "../TradeTron";
        navigate(path);
    }
    return(
        <>
            <section className="trade-box">
                <Container className="green-line">
                    <Row className="align-items-center ">
                        <Col md={5} sm={12} xs={12}  className="text-center">
                            <img src={Tradetrontool} alt="Tradetrontool-tool" className="img-fluid"></img>
                        </Col>
                        <Col md={7} sm={12} xs={12}>
                            <div className="tool-detail">
                                <h2>Trade Tron</h2>
                                <p>Powerful Algo trading platform for creating and trading Algos and strategies without having to write a single line of code</p>
                                <p>Set various conditions, duplicate available strategies for free and amend as per your requirements, without downloading any software.</p>
                                <span onClick={routeTradetron}>    
                                    <ReadMore name="Know" />
                                </span>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
}
export default TradeTron;